import moment from 'moment';

const isValidDate = (date) => moment(date).isValid();

export const gridDate = (date, format = 'MM/DD/YYYY') => {
  if (date && isValidDate(date)) return moment(date).format(format);
  else if (date && !isValidDate(date)) return 'Invalid Date';
  else return '';
};
